(() => {
  if (window.PurnamaVariantMediaGallery) return;
  const marker = /\[metal:(yellow-gold|rose-gold|white-gold|platinum|all)\]/i;
  const family = (values) => {
    const text = values.join(' ').toLowerCase();
    return ['yellow-gold', 'rose-gold', 'white-gold', 'platinum'].find((metal) => text.includes(metal.replaceAll('-', ' ')));
  };
  const metalOf = (item) => item.querySelector('img')?.alt.match(marker)?.[1]?.toLowerCase();
  const heroOf = (items, metal) => {
    const matches = items.filter((item) => metalOf(item) === metal);
    return matches.find((item) => /— front —|01[-_]front/i.test((item.querySelector('img')?.alt || '') + ' ' + (item.querySelector('img')?.src || ''))) || matches[0];
  };
  function apply(sectionId, selectedMetal) {
    const gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery || !selectedMetal) return false;
    const items = [...gallery.querySelectorAll('li[data-media-id]')];
    if (!items.some(metalOf)) return false;
    const white = heroOf(items, 'white-gold') ? 'white-gold' : 'platinum';
    const base = heroOf(items, white) ? white : metalOf(items.find(metalOf));
    const visual = ['platinum', 'white-gold'].includes(selectedMetal) ? white : selectedMetal;
    const hero = heroOf(items, visual);
    const baseHero = heroOf(items, base);
    const visible = items.filter((item) => {
      const metal = metalOf(item);
      return item === hero || !metal || metal === 'all' || (metal === base && item !== baseHero);
    });
    if (!hero && baseHero && !visible.length) visible.push(baseHero);
    const ids = new Set(visible.map((item) => item.dataset.mediaId));
    gallery.dataset.metalGallery = 'true';
    gallery.dataset.selectedMetal = selectedMetal;
    items.forEach((item) => {
      item.hidden = !ids.has(item.dataset.mediaId);
      item.setAttribute('aria-hidden', String(item.hidden));
    });
    gallery.querySelectorAll('[data-target]').forEach((item) => {
      item.hidden = !ids.has(item.dataset.target);
      item.setAttribute('aria-hidden', String(item.hidden));
    });
    // Keep the selected colour hero first in both the swipe gallery and thumbnails.
    if (hero) {
      if (hero.parentElement.firstElementChild !== hero) hero.parentElement.prepend(hero);
      const thumbnail = [...gallery.querySelectorAll('[data-target]')].find((item) => item.dataset.target === hero.dataset.mediaId);
      if (thumbnail && thumbnail.parentElement.firstElementChild !== thumbnail) thumbnail.parentElement.prepend(thumbnail);
    }
    if (!gallery.dataset.responsiveMediaBound) {
      gallery.dataset.responsiveMediaBound = 'true';
      window.matchMedia('(min-width: 750px)').addEventListener('change', () => {
        const active = gallery.querySelector('li[data-media-id].is-active:not([hidden])');
        requestAnimationFrame(() => {
          gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
          if (active) gallery.setActiveMedia?.(active.dataset.mediaId, { preserveScroll: true });
        });
      });
    }
    const note = gallery.querySelector('[data-metal-gallery-note]');
    if (note) {
      note.hidden = false;
      note.textContent = hero ? note.dataset.shared : note.dataset.missing;
    }
    if (gallery.dataset.activeMetal !== selectedMetal) {
      gallery.dataset.activeMetal = selectedMetal;
      const active = hero || visible[0];
      if (active) gallery.setActiveMedia?.(active.dataset.mediaId, { preserveScroll: true });
    }
    gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
    for (const metal of [white, 'yellow-gold', 'rose-gold']) {
      const image = heroOf(items, metal)?.querySelector('img');
      if (image && image.dataset.heroPrepared !== 'true') {
        image.dataset.heroPrepared = 'true';
        image.loading = 'eager';
        image.decode?.().catch(() => {});
      }
    }
    return true;
  }
  function applySelection(picker) {
    const values = [...picker.querySelectorAll('input[type="radio"]:checked, select option:checked')].map((input) => input.value);
    return apply(picker.dataset.section, family(values));
  }
  function init() { document.querySelectorAll('variant-selects').forEach(applySelection); }
  window.PurnamaVariantMediaGallery = { applyVariant: (sectionId, variant) => apply(sectionId, family(variant?.options || [])) };
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects');
    if (picker) applySelection(picker);
  }, true);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
